import React from 'react'
import Modal from 'react-modal'
import styles from './inbox.scss'
import nesProp from 'nested-property'
import { Table, Thead, Th, Tr, Td, collapseTd } from 'components/reactable'
import cs from 'classnames'
import i18n from 'lib/i18n'

const _ = i18n('inbox')

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
        overflow: 'visible'
    },
    content: {
        width: 'auto',
        position: 'relative',
        top: 'initial', bottom: 'initial', left: 'initial', right: 'initial',
        maxHeight: '90%',
        //minHeight: '50%',
        overflow: 'visible',
        padding: '0',
        wordWrap: "break-word"
    },
}

/**
 * This component will handle documents selection from ticket before opening the dsWizard
 * If there is only one ticket, this modal will be skipped
 */
export default class InboxDocumentsSigningModal extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedDocuments: [],
            attachmentSelectedDocuments: []
        }
    }

    /**
     * Used to reset the selected documents in case new ticket is being processed 
     * @param {*} nextProps 
     */
    componentWillReceiveProps(nextProps) {
        const ticket = nesProp.get(nextProps, "payload.ticket")
        const method = nesProp.get(nextProps, "method")
        const { selectedDocuments } = this.state
        if (selectedDocuments && selectedDocuments.length > 0 && ticket) {
            if (!selectedDocuments.some(selectedDoc => ticket.documents.includes(selectedDoc))) {
                this.setState({ selectedDocuments: [] })
            }
        }

        //fast forward if there is only one document
        if (ticket && ticket.documents && ticket.documents.length === 1) {
            method(ticket.documents, [], ticket)
        }
    }

    /**
     * Handle Ui event for individual checkbox
     * @param {*} ev 
     * @param {*} document 
     */
    onAddToSignChange(ev, document) {
        const { selectedDocuments, attachmentSelectedDocuments } = this.state
        const index = selectedDocuments.findIndex(oneDoc => oneDoc === document)
        if (index >= 0) {
            selectedDocuments.splice(index)
        } else {
            selectedDocuments.push(document)
            const attachmentIndex = attachmentSelectedDocuments.findIndex(oneDoc => oneDoc === document)
            if (attachmentIndex >= 0) {
                attachmentSelectedDocuments.splice(attachmentIndex, 1)
            }
        }
        this.setState({ selectedDocuments, attachmentSelectedDocuments })
    }

    /**
    * Handle Ui event for individual checkbox for email attachments
    * @param {*} ev 
    * @param {*} document 
    */
    onAddToAttachmentChange(ev, document) {
        const { attachmentSelectedDocuments, selectedDocuments } = this.state
        const index = attachmentSelectedDocuments.findIndex(oneDoc => oneDoc === document)
        if (index >= 0) {
            attachmentSelectedDocuments.splice(index)
        } else {
            attachmentSelectedDocuments.push(document)
            const signingDocIndex = selectedDocuments.findIndex(oneDoc => oneDoc === document)
            if (signingDocIndex >= 0) {
                selectedDocuments.splice(signingDocIndex, 1)
            }
        }
        this.setState({ selectedDocuments, attachmentSelectedDocuments })
    }

    /**
     * Handles form validation and next step click
     * @returns call to the method passed from parent component
     */
    handleOnNextClick() {
        const { selectedDocuments, attachmentSelectedDocuments } = this.state
        const { method, payload } = this.props
        const ticket = nesProp.get(payload, 'ticket')
        if (!selectedDocuments || selectedDocuments.length === 0) {
            return
        }

        return method(selectedDocuments, attachmentSelectedDocuments, ticket)
    }

    render() {
        const { selectedDocuments, attachmentSelectedDocuments } = this.state
        const { modalIsOpen, onCancel, payload, method } = this.props
        const ticket = nesProp.get(payload, 'ticket')
        const ticketDocuments = nesProp.get(ticket, "documents")
        const allSelected = ticketDocuments && selectedDocuments.length === ticketDocuments.length
        const isValid = selectedDocuments && selectedDocuments.length > 0 ? true : false
        return (
            <div>
                <Modal
                    isOpen={modalIsOpen}
                    onCancel={onCancel}
                    style={customStyles}
                    className={styles.modal}
                    contentLabel={""}
                >
                    <div className={styles.title}>{_('docSigningModal')}</div>

                    <div className={styles.contentWrapper}>
                        <Table
                            onVisibleChange={this.handleVisibleList}
                            filterable={[
                                "documentName"
                            ]}
                            ref={el => { this.table = el }}
                            id="table"
                            className="table"
                            sortable={[
                                'documentName',
                            ]}
                            defaultSort={{
                                column: 'documentName',
                                direction: 'desc',
                            }}

                            itemsPerPage={50}
                            pageButtonLimit={5}
                        >
                            <Thead>
                                <Th column="collapse" label="" />
                                <Th column="signCheckbox">
                                    <strong>{_("addToSignLabel")}</strong>
                                </Th>
                                <Th column="attachmentCheckbox">
                                    <strong>{_("addToEmailAttachment")}</strong>
                                </Th>
                                <Th column="documentName">
                                    <strong>{_("documentName")}</strong>
                                </Th>
                            </Thead>
                            {ticketDocuments && ticketDocuments.length && ticketDocuments.length > 0 ?
                                ticketDocuments.map((item, key) =>
                                    <Tr
                                        className={`clickable`}
                                        i={item}
                                        key={key}
                                    >
                                        <Td column="signCheckbox" >
                                            <div style={{ width: 15 }}>
                                                <input
                                                    type="checkbox"
                                                    onClick={ev => ev.stopPropagation()}
                                                    onChange={ev => this.onAddToSignChange(ev, item)}
                                                    checked={selectedDocuments.includes(item) ? true : false}
                                                />
                                            </div>
                                        </Td>
                                        <Td column="attachmentCheckbox" >
                                            <div style={{ width: 15 }}>
                                                <input
                                                    type="checkbox"
                                                    onClick={ev => ev.stopPropagation()}
                                                    onChange={ev => this.onAddToAttachmentChange(ev, item)}
                                                    checked={attachmentSelectedDocuments.includes(item) ? true : false}
                                                />
                                            </div>
                                        </Td>
                                        <Td column="documentName" value={item}>{item}</Td>
                                    </Tr>
                                ) : ''
                            }
                        </Table>
                        <div className={styles.buttons}>
                            <div
                                onClick={onCancel}
                                className={cs(styles.cancel)}
                            >
                                {_('cancel')}
                            </div>

                            <div
                                onClick={() => this.handleOnNextClick()}
                                className={cs(styles.next, isValid ? styles.enabled : styles.disabled)}
                            >
                                {_("ok")}
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/inboxDocumentsSigningModal.jsx